

















































import { defineComponent, ref, PropType } from '@vue/composition-api';
import TtamSavedAudienceCreateDialog from '../dialog/index.vue';
import { Message } from 'byted-vui';
import { i18n } from './../../../../i18n';
import { trackEvent } from './../../../../utils/index';

const name = 'ttam-saved-audience-create-subcpn';
export default defineComponent({
  name,
  components: {
    TtamSavedAudienceCreateDialog,
  },
  props: {
    detailData: {
      type: Object,
      default: () => ({}),
    },
    learnMoreHref: {
      type: String,
      default: '',
    },
    saveAudience: {
      type: Function as PropType<
        (
          savedAudienceName: string,
        ) => Promise<{ savedAudienceFull?: boolean; success: boolean; savedAudienceId?: number }>
      >,
      default: () => () => undefined,
    },
  },
  setup(props, { emit }) {
    // const { saveAudience } = props;
    const savedAudienceCreateDialogRef = ref(null);
    const isMaxNumberDialogShow = ref(false);
    const isSubmitLoading = ref(false);
    function handleClickSavedButton() {
      emit('on-create');
      savedAudienceCreateDialogRef.value.dialogVisible = true;
    }
    async function handleSavedAudienceCreate({ savedAudienceName }) {
      if (isSubmitLoading.value) {
        return;
      }
      isSubmitLoading.value = true;
      const { success, savedAudienceFull, savedAudienceId } = await props.saveAudience(savedAudienceName);
      if (success) {
        if (savedAudienceFull) {
          savedAudienceCreateDialogRef.value.dialogVisible = false;
          isMaxNumberDialogShow.value = true;
          trackEvent('create_new_saved_audience_submit', {
            is_success: 1,
          });
        } else {
          emit('saved-success', savedAudienceId);
          Message.success(`${i18n.t('adgroup_target_create_saved_audience_success')}`);
          savedAudienceCreateDialogRef.value.handleCloseDialog &&
            savedAudienceCreateDialogRef.value.handleCloseDialog();
          trackEvent('create_new_saved_audience_submit', {
            is_success: 0,
          });
        }
      } else {
        Message({
          type: 'error',
          message: `${i18n.t('adgroup_target_create_saved_audience_fail')}, ${i18n.t(
            'adgroup_target_saved_audience_dialog_retry',
          )}`,
        });
        trackEvent('create_new_saved_audience_submit', {
          is_success: 2,
        });
      }
      isSubmitLoading.value = false;
    }

    function manageSavedAudience() {
      emit('on-manage-audience');
      isMaxNumberDialogShow.value = false;
    }
    return {
      name,
      isMaxNumberDialogShow,
      isSubmitLoading,
      handleClickSavedButton,
      handleSavedAudienceCreate,
      manageSavedAudience,
      savedAudienceCreateDialogRef,
    };
  },
});
